<template>
  <div>
    <!-- Breadcrumb -->
    <app-breadcrumb>
      <template #contentright>
        <b-button
          variant="outline-primary"
          :to="{ name: 'mobile-vehicle-add' }"
        >
          <span class="text-nowrap">
            <feather-icon icon="PlusCircleIcon" /> {{ $t('Add New') }}
          </span>
        </b-button>
      </template>
    </app-breadcrumb>

    <!-- Filters -->
    <mobile-vehicle-list-filters
      @search="searchAll"
      :manufactureData="frmManufacture"
    />

    <!-- Table Container Card -->
    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-card
        no-body
        class="mb-0"
      >
        <div class="m-2">
          <!-- Table Top -->
          <b-row>
            <!-- Per Page -->
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>{{ $t('Show') }}</label>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
              />
              <label>{{ $t('entries') }}</label>
            </b-col>
            <b-col />
          </b-row>
        </div>
        <b-table
          ref="refUserListTable"
          class="position-relative table-nowrap"
          :items="itemsData"
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          responsive
          show-empty
          empty-text="Không tìm thấy kết quả"
          :sort-desc.sync="isSortDirDesc"
        >
          <!-- Column: id -->
          <template #cell(index)="data">
            {{ data.index + 1 }}
          </template>
          <!-- Column: Status -->
          <template #cell(status)="row">
            <b-badge
              pill
              :variant="`light-${resolveStatusVariant(row.item.status)}`"
              class="text-capitalize"
            >
              {{ resolveStatusText(row.item.status) }}
            </b-badge>
          </template>
          <template #cell(usage_status)="row">
            <b-badge
              pill
              class="text-capitalize"
            >
              {{ resolveUsageStatusText(row.item.usage_status) }}
            </b-badge>
          </template>
          <template #cell(manufacture_id)="row">
            {{ row.item.manufacture ? row.item.manufacture.name : '' }}
          </template>
          <!-- Column: Actions -->
          <template #cell(actions)="row">
            <b-button
              size="sm"
              class="btn-icon ml-1"
              v-b-tooltip.hover
              title="Sửa"
              variant="outline-primary"
              :to="{ name: 'mobile-vehicle-edit', params: { id: row.item.id } }"
            >
              <span class="text-nowrap">
                <feather-icon icon="EditIcon" />
              </span>
            </b-button>
            <!-- v-if="$can('articleType.destroy', 'ArticleType')" -->
            <b-button
              size="sm"
              class="ml-1 btn-icon"
              variant="outline-danger"
              @click="confirmDelete(row.item.id)"
              v-b-tooltip.hover
              title="Xóa"
            >
              <span class="text-nowrap">
                <feather-icon icon="TrashIcon" />
              </span>
            </b-button>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">{{
                $t('show_to_entries', {
                  from: dataMeta.from,
                  to: dataMeta.to,
                  of: dataMeta.of,
                })
              }}</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalEntries"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>

    <b-modal
      id="showRelate1"
      body-class=" mb-2"
      size="lg"
      @close="dialog"
      cancel-variant="outline-secondary"
      no-close-on-backdrop
      hide-footer
      :title="editMode ? 'Cập nhật' : 'Thêm mới'"
    >
      <studio-edit
        :mdata="frmData"
        @updateData="handleDialog"
      />
    </b-modal>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required, email, alphaNum, min, max } from '@validations';
import {
  BOverlay,
  BCard,
  BRow,
  BCol,
  BButton,
  BTable,
  BFormCheckbox,
  BBadge,
  BPagination,
  BModal,
  BFormGroup,
  BFormTextarea,
  BFormInput,
  BForm,
  BFormInvalidFeedback,
  VBTooltip
} from 'bootstrap-vue';
import { ref } from '@vue/composition-api';
import { showToast } from '@/@core/utils/utils';
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue';
import MobileVehicleListFilters from './MobileVehicleListFilters.vue';
import useMobileVehicle from './useMobileVehicle';
import formValidation from '@core/comp-functions/forms/form-validation';
import store from '@/store';
import MobileVehicleEdit from './MobileVehicleEdit.vue';
import vSelect from 'vue-select';
import Ripple from 'vue-ripple-directive';
export default {
  components: {
    AppBreadcrumb,
    MobileVehicleListFilters,
    BOverlay,
    BCard,
    BRow,
    BCol,
    BButton,
    BTable,
    BBadge,
    BPagination,
    BFormCheckbox,
    BModal,
    BFormGroup,
    BFormTextarea,
    BFormInput,
    ValidationProvider,
    ValidationObserver,
    BForm,
    BFormInvalidFeedback,
    MobileVehicleEdit,
    vSelect,
  },
  data() {
    return {
      editMode: false,
    };
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  setup() {
    const isAddNewUserSidebarActive = ref(false);
    const blankData = {
      id: null,
      name: '',
      manufacture_id: null,
      description: '',
    };
    const frmData = ref(JSON.parse(JSON.stringify(blankData)));
    const resetfrmData = () => {
      frmData.value = JSON.parse(JSON.stringify(blankData));
    };
    const frmManufacture = ref([]);
    const fetchManufacture = () => {
      store.dispatch('manufacturer/fetchAll', {
        isPaginate: 0,
        type: 20,
      })
        .then(response => {
          if (response.data.code === 200) {
            frmManufacture.value = response.data.data;
          }
        })
    }
    fetchManufacture();
    const {
      loading,
      fetchAll,
      tableColumns,
      perPage,
      currentPage,
      totalEntries,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      itemsData,
      resolveStatusVariant,
      resolveStatusText,
      resolveUsageStatusText,
      statusFilter,
    } = useMobileVehicle();

    fetchAll();
    const { refFormObserver, getValidationState, resetForm } =
      formValidation(frmData);
    return {
      fetchAll,
      // Sidebar
      isAddNewUserSidebarActive,
      loading,
      tableColumns,
      perPage,
      currentPage,
      totalEntries,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      itemsData,
      frmData,
      getValidationState,
      resetfrmData,
      resolveStatusVariant,
      resolveStatusText,
      resolveUsageStatusText,
      statusFilter,
      frmManufacture
    };
  },
  methods: {
    handleDialog() {
      this.$bvModal.hide('showRelate1');
      this.fetchAll();
      this.resetfrmData();
    },
    dialog() {
      this.editMode = false;
      this.resetfrmData();
      this.$bvModal.show('showRelate1');
    },
    edit(item) {
      this.frmData = item;
      this.editMode = true;
      this.$bvModal.show('showRelate1');
    },
    confirmDelete(id) {
      this.$swal({
        title: 'Bạn chắc muốn xóa?',
        text: 'Xóa dữ liệu sẽ ảnh hưởng đến các chức năng khác trong hệ thống!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Có',
        cancelButtonText: 'Không',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch('mobileVehicle/destroy', { id }).then((res) => {
            if (res.status === 200) {
              this.fetchAll();
              showToast(res.data.message, { variant: 'success' });
            } else {
              showToast(res.data.message);
            }
          });
        }
      });
    },
    searchAll(data) {
      this.searchQuery.keyword = data.keyword;
      this.searchQuery.manufacture_id = data.manufacture_id;
      this.searchQuery.status = data.status;
      this.searchQuery.usageStatus = data.usageStatus;
      this.fetchAll();
    },
  },
};
</script>
